import { useEffect, useRef } from 'react'

// Triggers onTrigger after timeoutMs of no user activity (mouse/keyboard/scroll/touch).
export function useIdleLogout(timeoutMs = 14 * 60 * 1000, onTrigger) {
  const timer = useRef(null)
  const reset = () => { clearTimeout(timer.current); timer.current = setTimeout(onTrigger, timeoutMs) }
  useEffect(() => {
    reset()
    const evts = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart']
    evts.forEach(e => window.addEventListener(e, reset))
    return () => { clearTimeout(timer.current); evts.forEach(e => window.removeEventListener(e, reset)) }
  }, [])
}
